import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {Form, FormikProvider, useFormik} from 'formik';
import * as Yup from 'yup';
import * as fileActions from '../_redux/actions/OrderFilesActions';
import {useOrderDetailsUIGlobalContext} from './OrderDetailsUIGlobalContext';

export function OrderDetailsUIFormChangeNameProvider({fileID, currentFileName, onSubmit, children}) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const {orderID} = useOrderDetailsUIGlobalContext();

  const invalidNameMessage = intl.formatMessage({
    id: 'tab-order-documents-form-invalidName',
    defaultMessage: 'this name already exists',
  });

  const getName = (fileName) => {
    const [originalName] = fileName.split('.');
    return originalName;
  };

  const getExtension = (fileName) => {
    const [/*originalName*/, extension] = fileName.split('.');
    return extension;
  };

  const formik = useFormik({
    initialValues: {fileName: getName(currentFileName)},
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      fileName: Yup.string().required('Name is required').test(
        'is-not-existed-name',
        invalidNameMessage,
        async (value) => {
          try {
            const extension = getExtension(currentFileName);
            const result = await fileActions.validateFileName(orderID, [value, extension].join('.'));
            return result.isValid;
          } catch (e) {
            return false;
          }
        }
      ),
    }),
    onSubmit: async (values) => {
      try {
        const extension = getExtension(currentFileName);
        await fileActions.updateFileName(orderID, fileID, [values.fileName, extension].join('.'));
        await dispatch(fileActions.getFileList(orderID));
        if (onSubmit) {
          onSubmit();
        }
      } catch (e) {
        console.error(e);
      }
    }
  });

  return (
    <FormikProvider value={formik}>
      <Form>{children}</Form>
    </FormikProvider>
  );
}

OrderDetailsUIFormChangeNameProvider.propTypes = {
  children: PropTypes.node,
  fileID: PropTypes.number.isRequired,
  currentFileName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
};